import { mapGetters } from "vuex";

export default {
	computed: {
		...mapGetters(["savingsStatistics", "subscriptionDetails", "priceRules", "customerDetails"]),
		monthsOfPLUSMembership() {
			return (((this.customerDetails || {}).meta || {}).subscription || {}).consecutiveMonthChargesNumber;
		},
		milestonePriceRules() {
			const isSunsetBusiness = this.subscriptionDetails.subscriptionPlanName
				&& this.subscriptionDetails.subscriptionPlanName.includes("Business");
			if (!this.priceRules || isSunsetBusiness) {
				return [];
			}
			return this.priceRules.filter(this.filterFn()).sort(this.sortFn);
		},
		milestonesAchieved() {
			return this.milestonePriceRules.filter(x => this.monthsOfPLUSMembership >= x.options.milestoneRewardInterval);
		},
		getSavings() {
			return this.savingsStatistics ? this.savingsStatistics.allTime || 0 : 0;
		}
	},
	methods: {
		filterFn() {
			const planName = this.subscriptionDetails.subscriptionPlanName.toLowerCase();
			const plan = planName.includes("basic") ? "basic" : planName.includes("premium") ? "premium" : "exclusive";
			return (x) => {
				if (!x.options
				|| !x.options.label
				|| !x.options.label.toLowerCase().includes(`MilestoneReward${plan}`.toLowerCase())
				|| !(x.voucherPattern && x.voucherPattern.length)
				|| !(x.productPattern && x.productPattern.length)) {
					return false;
				}
				return x;
			};
		},
		sortFn(a,b) {
			return a.options.milestoneRewardInterval < b.options.milestoneRewardInterval ? -1 : 1;
		}
	}
};
